export const ru = {
    'site-link-descr': 'Описание',
    'site-link-different-values-placeholder':
        'В выбранных объявлениях разные значения',
    'site-link-link': 'Ссылка на сайт',
    'site-link-placeholder': 'Заполните поле',
    'site-link-title': 'Заголовок'
};
